<template>
  <div class="table-filter-option">
    Show
    <InputSelect
      v-model="perPage"
      :options="paginationOptions"
      optionValue="id"
      optionLabel="name"
      placeholder="5"
      @optionSelected="changedPerPage"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

const perPage = defineModel<number>({ default: 5 });

const emit = defineEmits(['changedResultsPerPage']);

const paginationOptions = ref([
  {id: 5, name: '5 Rows'},
  {id: 10, name: '10 Rows'},
  {id: 20, name: '20 Rows'},
  {id: 50, name: '50 Rows'}
]);

const changedPerPage = (newCount: number) => {
  perPage.value = newCount;
  emit('changedResultsPerPage', perPage.value);
}

</script>
